<script setup lang="ts">
import { ref } from 'vue'
import DropdownButton from '../ui/common/DropdownButton.vue'
import ReportsDialog from './ReportsDialog.vue'
import ReportViewer from './ReportViewer.vue'
import { Report } from '../../types/models';

defineProps<{
  reports?: Report[] | any[]
}>()
const showMoreReports = ref(false)

const handleMoreReports = (event: MouseEvent) => {
  event.stopPropagation() // Prevent the dropdown from closing
  showMoreReports.value = true
}

const closeMoreReports = () => {
  showMoreReports.value = false
}

const reportId = ref('')
const handleReportSelect = (id: any) => {
  reportId.value = id
  showReport.value = true
}

defineEmits<{
  (e: 'select', reportId: number | string): void
}>()

const showReport = ref(false);

const handleRowExpand = (row: any) => {
  console.log('Row expanded:', row);
};

</script>

<template>
  <div class="relative" v-if="reports && reports.length > 0">
    <DropdownButton text="Reports" icon="ChartSpline">
      <div class="py-1">
        <!-- First 5 reports -->
        <button
          v-for="report in reports.slice(0, 5)"
          :key="report.uid"
          @click="handleReportSelect(report.uid)"
          class="block w-full px-4 py-2 text-sm text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          {{ report.name }}
        </button>

        <template v-if="reports.length > 5" >
        <!-- Separator -->
        <div class="border-t border-gray-200 dark:border-gray-700 my-1"></div>

        <!-- More Reports button -->
        <button
          @click="handleMoreReports"
          class="block w-full px-4 py-2 text-sm text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          More Reports...
        </button>
      </template>
      </div>
    </DropdownButton>

    <!-- Reports Dialog -->
    <ReportsDialog
      v-if="showMoreReports"
      :reports="reports"
      @close="closeMoreReports"
      @select="handleReportSelect"
    />

    <ReportViewer 
      :report-id="reportId"
      @row-expand="handleRowExpand"
      :show="showReport"
      @close="reportId = ''; showReport = false"
    />

  </div>
</template>